/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataImportFileType } from './DataImportFileType';
import {
    DataImportFileTypeFromJSON,
    DataImportFileTypeFromJSONTyped,
    DataImportFileTypeToJSON,
} from './DataImportFileType';
import type { DataImportStatus } from './DataImportStatus';
import {
    DataImportStatusFromJSON,
    DataImportStatusFromJSONTyped,
    DataImportStatusToJSON,
} from './DataImportStatus';

/**
 * 
 * @export
 * @interface DataImport
 */
export interface DataImport {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DataImport
     */
    importMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof DataImport
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    message?: string;
    /**
     * 
     * @type {DataImportFileType}
     * @memberof DataImport
     */
    fileType: DataImportFileType;
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof DataImport
     */
    finishedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DataImport
     */
    startedAt: Date;
    /**
     * 
     * @type {DataImportStatus}
     * @memberof DataImport
     */
    status: DataImportStatus;
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof DataImport
     */
    id: string;
}



/**
 * Check if a given object implements the DataImport interface.
 */
export function instanceOfDataImport(value: object): value is DataImport {
    if (!('tags' in value) || value['tags'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DataImportFromJSON(json: any): DataImport {
    return DataImportFromJSONTyped(json, false);
}

export function DataImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImport {
    if (json == null) {
        return json;
    }
    return {
        
        'importMetadata': json['importMetadata'] == null ? undefined : json['importMetadata'],
        'tags': json['tags'],
        'message': json['message'] == null ? undefined : json['message'],
        'fileType': DataImportFileTypeFromJSON(json['fileType']),
        'fileName': json['fileName'],
        'finishedAt': json['finishedAt'] == null ? undefined : (new Date(json['finishedAt'])),
        'startedAt': (new Date(json['startedAt'])),
        'status': DataImportStatusFromJSON(json['status']),
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function DataImportToJSON(value?: DataImport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'importMetadata': value['importMetadata'],
        'tags': value['tags'],
        'message': value['message'],
        'fileType': DataImportFileTypeToJSON(value['fileType']),
        'fileName': value['fileName'],
        'finishedAt': value['finishedAt'] == null ? undefined : ((value['finishedAt']).toISOString()),
        'startedAt': ((value['startedAt']).toISOString()),
        'status': DataImportStatusToJSON(value['status']),
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

